import React, { Component } from 'react';
import StatCard from './StatCard';

export default class QuickStats extends Component {
  render() {
    return (
      <div
        className="Dashboard"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
        }}
      >
        {this.props.stats.map(stat => (
          <StatCard
            value={stat.value}
            label={stat.label}
            background={stat.background}
            color={stat.color}
            style={{
              flex: 1,
              minWidth: 100,
            }}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/QuickStats.js